module.exports = __webpack_public_path__ + "static/media/6.1 Blumenstillleben nach_klein.8fdb0b0c.jpg";